module.exports = __webpack_public_path__ + "fonts/ProximaNova-Light.35979111.eot";